<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :loading="loading"
      :items="CVs"
      :items-per-page="10"
      :disable-sort="$vuetify.breakpoint.smAndDown"
      :footer-props="{'items-per-page-text': 'Số Hồ Sơ một trang'}"
      v-bind="this.$attrs"
    >
      <template v-slot:[`footer.page-text`]="items">
        Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
      </template>
      <template v-slot:[`item.code`]="{item}">
        <v-btn
          class="document-btn text-none text-decoration-underline px-0"
          color="primary"
          @click="() => $emit('onDocumentDetail', item.id)"
          plain
        >
          {{ item | getCode }}
        </v-btn>
      </template>
      <template v-slot:[`item.department`]="{item}">
        {{ item | getDepartment }}
      </template>
      <template v-slot:[`item.name`]="{item}">
        {{ item | getStudent }}
      </template>
      <template v-slot:[`item.dob`]="{item}">
        {{ item | getStudentDob }}
      </template>
      <template v-slot:[`item.examMathMark`]="{item}">
        {{ item | getExamMathMark }}
      </template>
      <template v-slot:[`item.examLanguage`]="{item}">
        {{ item | getExamLanguage }}
      </template>
      <template v-slot:[`item.priorityMark`]="{item}">
        {{ item | getPriorityMark }}
      </template>
      <template v-slot:[`item.examTotal`]="{item}">
        {{ item | getTotalMark }}
      </template>
      <template v-slot:[`item.expectation1`]="{item}">
        {{ getShortClassName(item, 1) }}
      </template>
      <template v-slot:[`item.expectation2`]="{item}">
        {{ getShortClassName(item, 2) }}
      </template>
      <template v-slot:[`item.expectation3`]="{item}">
        {{ getShortClassName(item, 3) }}
      </template>
      <template v-slot:[`item.examPass`]="{item}">
        <span :class="getColor(item)">{{ item | passExamText }}</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import {mapActions, mapGetters} from 'vuex'
import {get} from 'lodash'
import moment from 'moment'
import {originHeaders, getPassExamText, getShortClassName} from './Grade6Result/resultTableHelpers'

export default {
  computed: {
    ...mapGetters('cv', ['CVs', 'CV', 'count']),
    ...mapGetters('auth', ['user']),
    headers: () => originHeaders
  },
  data: () => ({loading: false}),
  async mounted() {
    let query = {
      _sort: 'updatedAt:DESC'
    }
    if (this.user.department === 'both') query.department_in = ['Cơ sở A', 'Cơ sở 1', 'unset']
    else query.department_in = [this.user.department, 'unset']
    await this.refresh(query)
  },
  methods: {
    ...mapActions('cv', ['fetchCVs', 'fetchCV', 'updateCV']),
    onDocumentClick(documentId) {
      this.$emit('onDocumentDetail', documentId)
    },
    async refresh(query) {
      this.loading = true
      await this.fetchCVs({
        ...query,
        type: 'Khối 6'
      })
      this.loading = false
    },
    getColor(item) {
      const passExamType = get(item, 'ltvExamResult.passExamType')
      if (passExamType === 'pass') return 'success--text'
      if (passExamType === 'violation') return 'error--text'
      return ''
    },
    getShortClassName
  },
  filters: {
    getStudent: item => get(item, 'name', '---'),
    getDepartment: item => (!item.department || item.department === 'unset' ? '---' : item.department),
    getCode: item => get(item, 'code', '---'),
    getStudentDob: item => (item.dob ? moment(item.dob).format('DD/MM/YYYY') : '---'),
    getExamMathMark: item => get(item, 'ltvExamResult.examMathMark', '---'),
    getExamLanguage: item => get(item, 'ltvExamResult.examLanguage', '---'),
    getPriorityMark: item => get(item, 'ltvExamResult.priorityMark', '---'),
    getTotalMark: item => get(item, 'ltvExamResult.examTotal', '---'),
    passExamText: item => getPassExamText(item)
  }
}
/* eslint-enable no-unused-vars */
</script>
